import { render } from "./MediaGallery.vue?vue&type=template&id=15252042&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=15252042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15252042"]])

export default __exports__